import { EmbeddedRecordsMixin } from '@ember-data/serializer/rest';
import ApplicationSerializer from 'lumen/serializers/application';

// eslint-disable-next-line @typescript-eslint/no-unsafe-call
export default class CentralMappingMarketSubscriptionSerializer extends ApplicationSerializer.extend(
  EmbeddedRecordsMixin,
) {
  attrs = {
    brandsDetails: { embedded: 'always' },
    chainsDetails: { embedded: 'always' },
  };

  primaryKey: string = 'subscription_id';

  modelNameFromPayloadKey(key: string): string {
    if (key === 'subscriptions') {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-return
      return super.modelNameFromPayloadKey(
        'central-mapping/market-subscription',
      );
    }

    return key;
  }
}
